import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const PieChart = ({ chartData }) => {
  useEffect(() => {
    // Create root element
    let root = am5.Root.new("piechartdiv");
    root._logo.dispose();

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
      })
    );

    // Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
      })
    );

    series
      .get("colors")
      .set("colors", [
        am5.color("#FF3A29"),
        am5.color("#FFB200"),
        am5.color("#51CF66"),
        am5.color("#51CF667"),
        am5.color("#51CF668"),
      ]);

    // Set data
    series.data.setAll(chartData);

    // Remove labels from slices
    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    // Set colors
    series.slices.template.setAll({
      fillOpacity: 0.9,
      strokeOpacity: 0,
    });

    // Create legend
    var legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(100),
        x: am5.percent(100),
        layout: root.verticalLayout,
      })
    );

    // Link legend to the series
    legend.data.setAll(series.dataItems);

    // Customize legend items
    legend.markers.template.setAll({
      width: 15,
      height: 15,
      borderRadius: 10,
    });

    legend.labels.template.setAll({
      text: "{category}",
    });

    // Play initial series animation
    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chartData]);

  return (
    <div id="piechartdiv" style={{ width: "100%", height: "300px" }}></div>
  );
};

export default PieChart;
